import { render } from "./VisionVentureLayout.vue?vue&type=template&id=469a28b0&scoped=true"
import script from "./VisionVentureLayout.vue?vue&type=script&lang=js"
export * from "./VisionVentureLayout.vue?vue&type=script&lang=js"

import "./VisionVentureLayout.vue?vue&type=style&index=0&id=469a28b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469a28b0"]])

export default __exports__